export { ModalPrimitive } from './Primitive';
export { ModalProvider } from './Context/ModalProvider';
export { useModal } from './Context/useModal';
